module.exports = __webpack_public_path__ + "static/media/pexels-kripesh-adwani-709134.0ba7ef1a.jpg";